import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { ButtonAppearance, ButtonShape, ButtonSize } from '@tablekit/button';
import { Icon } from '@tablekit/icon';
import { AlertCloseButton as AlertCloseButton$1 } from '../styled.js';
import { jsx } from '@emotion/react/jsx-runtime';

var AlertCloseButton = function AlertCloseButton(_ref) {
  var onClick = _ref.onClick;
  return jsx(AlertCloseButton$1, {
    appearance: ButtonAppearance.Subtle,
    shape: ButtonShape.Circular,
    onClick: onClick,
    iconBefore: function iconBefore() {
      return jsx(Icon, {
        icon: faTimes
      });
    },
    size: ButtonSize.Small
  });
};

export { AlertCloseButton };
